export default {"src":"/_next/static/media/globalCover_40.ddb62e0c.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};